import { FC, useContext } from "react";
import { DrawerContext } from "../../../../contexts/drawer/context";
import { HeaderComponent } from "./component";

export const HeaderContainer: FC = () => {
  const { handleDrawerToggle } = useContext(DrawerContext);

  return <HeaderComponent handleDrawerToggle={handleDrawerToggle} />;
};
